import { httpPatch } from "../connection.js";

const updateCustomField = async (values = {}) => {
  const { field_id, ...rest } = values;
  return await httpPatch(`/custom-fields/${field_id}`, rest);
};

const CustomFieldsAPI = {
  updateCustomField,
};

export default CustomFieldsAPI;
